import { z } from 'zod';

// ─── Auth Event Payloads ────────────────────────────────────────────
// Zod schemas for every auth-domain event.
// Published directly from the API auth routes (not via Amber, as these
// are synchronous responses rather than background async work).

export const LoginSucceededPayload = z.object({
    userId:       z.string().min(1),
    email:        z.string().email(),
    tenantIds:    z.array(z.string()).default([]),
    authProvider: z.string().nullable().optional(),
});

export type LoginSucceededPayload = z.infer<typeof LoginSucceededPayload>;

export const MfaEnabledPayload = z.object({
    userId: z.string().min(1),
    email:  z.string().email(),
});

export type MfaEnabledPayload = z.infer<typeof MfaEnabledPayload>;

export const MfaDisabledPayload = z.object({
    userId: z.string().min(1),
    email:  z.string().email(),
});

export type MfaDisabledPayload = z.infer<typeof MfaDisabledPayload>;
